import RequestLoaderTriggerLogic from "./RequestLoaderTriggerLogic";

const RequestLoaderTrigger = ({ children }) => {
  RequestLoaderTriggerLogic();

  return children;
};
export default RequestLoaderTrigger;
